var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header__nav-login" }, [
    _c(
      "div",
      { staticClass: "header__nav-loginBox" },
      [
        _c(
          "v-btn",
          {
            staticClass: "btn-login",
            on: {
              click: function($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.openLoginDialog($event)
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("front.header.button.login")))]
        ),
        _c(
          "v-btn",
          {
            staticClass: "btn-register",
            on: { click: _vm.openRegistrationDialog }
          },
          [_vm._v(_vm._s(_vm.$t("front.header.button.register")))]
        ),
        _vm.$store.state.signIn.loginDialog
          ? _c(
              "v-dialog",
              {
                attrs: {
                  scrollable: "",
                  "content-class": "dialog-login",
                  "max-width": "472px",
                  persistent: _vm.isDialogPersistent
                },
                model: {
                  value: _vm.$store.state.signIn.loginDialog,
                  callback: function($$v) {
                    _vm.$set(_vm.$store.state.signIn, "loginDialog", $$v)
                  },
                  expression: "$store.state.signIn.loginDialog"
                }
              },
              [
                _c("login", {
                  on: {
                    openRegister: _vm.openRegistrationDialog,
                    openForgot: _vm.openForgotDialog
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.$store.state.signIn.registrationDialog
          ? _c(
              "v-dialog",
              {
                attrs: {
                  scrollable: "",
                  "content-class": "dialog-register",
                  "max-width": "900px",
                  persistent: _vm.isDialogPersistent
                },
                model: {
                  value: _vm.$store.state.signIn.registrationDialog,
                  callback: function($$v) {
                    _vm.$set(_vm.$store.state.signIn, "registrationDialog", $$v)
                  },
                  expression: "$store.state.signIn.registrationDialog"
                }
              },
              [
                _vm.allowQuickRegister
                  ? _c("quick-register", {
                      on: { openLogin: _vm.openLoginDialog }
                    })
                  : _c("register", { on: { openLogin: _vm.openLoginDialog } })
              ],
              1
            )
          : _vm._e(),
        _vm.$store.state.signIn.forgotPasswordDialog
          ? _c(
              "v-dialog",
              {
                attrs: {
                  scrollable: "",
                  "content-class": "dialog-forgot",
                  "max-width": "472px",
                  persistent: _vm.isDialogPersistent
                },
                model: {
                  value: _vm.$store.state.signIn.forgotPasswordDialog,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.$store.state.signIn,
                      "forgotPasswordDialog",
                      $$v
                    )
                  },
                  expression: "$store.state.signIn.forgotPasswordDialog"
                }
              },
              [
                _c("forgot-password", {
                  on: { openLogin: _vm.openLoginDialog }
                })
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }